import { withFormik } from 'formik';
import { validation, required } from '../../forms/util/validation'; // import { AuthenticationState } from "react-aad-msal"

import * as yup from 'yup';
var validationSchema = yup.object().shape({
  // firstName: validation.firstName,
  // lastName: validation.lastName,
  // email: validation.emailAddress,
  // phone: validation.phoneNumber,
  address1: required('Address is required'),
  city: required('City is required'),
  state: required('State is required'),
  zipCode: validation.zipCode
});
export var formikEnhancer = withFormik({
  enableReinitialize: false,
  mapPropsToValues: function mapPropsToValues(props) {
    var _props$address, _props$address2, _props$address3, _props$address4, _props$address5, _props$address6, _props$address7, _props$address8;

    return {
      firstName: (_props$address = props.address) === null || _props$address === void 0 ? void 0 : _props$address.firstName,
      lastName: (_props$address2 = props.address) === null || _props$address2 === void 0 ? void 0 : _props$address2.lastName,
      // email: props.email,
      // phone: props.phone,
      address1: (_props$address3 = props.address) === null || _props$address3 === void 0 ? void 0 : _props$address3.address1,
      address2: (_props$address4 = props.address) === null || _props$address4 === void 0 ? void 0 : _props$address4.address2,
      city: (_props$address5 = props.address) === null || _props$address5 === void 0 ? void 0 : _props$address5.city,
      state: (_props$address6 = props.address) === null || _props$address6 === void 0 ? void 0 : _props$address6.state,
      zipCode: (_props$address7 = props.address) === null || _props$address7 === void 0 ? void 0 : _props$address7.zipCode,
      addressId: (_props$address8 = props.address) === null || _props$address8 === void 0 ? void 0 : _props$address8.addressId
    };
  },
  validationSchema: validationSchema,
  handleSubmit: function handleSubmit(values, _ref) {
    var props = _ref.props;

    if (typeof props.postAccountAddress !== 'function') {
      return false;
    }

    var data = {
      firstName: values.firstName,
      lastName: values.lastName,
      address1: values.address1,
      address2: values.address2,
      city: values.city,
      state: values.state,
      zipCode: values.zipCode
    };

    if (props.address.addressId && props.address.addressId !== '') {
      data['addressId'] = props.address.addressId;
    }

    props.postAccountAddress(data, props.addresses);
    props.setShowAddressForm(false);
    props.setActiveAddress({});
  },
  displayName: 'My Account' // helps with React DevTools

});